import React from "react";

const Lotteries = () => {
    return (
        <div>This is Lotteries</div>
    )
}

export default Lotteries;